/**
 ⚠️ Design System — Protected file
 Do not edit this file without prior approval from the Design System team.
 */

import { ProgressBarType } from 'ui/designSystem/ProgressBar/types'

import { clamp } from './clamp'

export const getProgressText = (type: ProgressBarType, value: number, max: number) => {
  const clampedValue = clamp(value, max)

  if (type === 'steps') return `${clampedValue}/${max}`

  return `${Math.round(clampedValue)}%`
}
